import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { BonusCampaignType } from '../../@types/api';
import { StyleObj } from '../../@types';
import { BONUS_CAMPAIGN_TYPE_OPTIONS } from '../../constants';

const styles: StyleObj = {
  formControl: {
    minWidth: 200,
  },
};

type BonusTypeSelectProps = {
  value: BonusCampaignType;
  onChange: (event: SelectChangeEvent<BonusCampaignType>) => void;
};

const BonusTypeSelect = ({ value, onChange }: BonusTypeSelectProps) => {
  return (
    <FormControl sx={styles.formControl}>
      <InputLabel>Bonus Type</InputLabel>
      <Select value={value} onChange={onChange} label='Bonus Type'>
        {BONUS_CAMPAIGN_TYPE_OPTIONS.map((bonusType) => (
          <MenuItem key={bonusType.id} value={bonusType.id}>
            {bonusType.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BonusTypeSelect;
